import React from 'react';
import { Tabs as TabsStyled, TabItem } from './TabsStyled';

type Props = {
  list: string[];
  active?: string;
  onChange: (active: any) => void;
};

export const Tabs: React.FC<Props> = ({ list, active, onChange }) => {
  return (
    <TabsStyled>
      {list.map((title, i: number) => (
        <TabItem
          key={i}
          isActive={active === title}
          onClick={() => onChange(title)}
        >
          {title}
        </TabItem>
      ))}
    </TabsStyled>
  );
};
